import { render, staticRenderFns } from "./DialogPhone.vue?vue&type=template&id=4ee52b3d&scoped=true"
import script from "./DialogPhone.vue?vue&type=script&lang=js"
export * from "./DialogPhone.vue?vue&type=script&lang=js"
import style0 from "./DialogPhone.vue?vue&type=style&index=0&id=4ee52b3d&prod&scoped=true&lang=css"
import style1 from "./DialogPhone.vue?vue&type=style&index=1&id=4ee52b3d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee52b3d",
  null
  
)

export default component.exports